import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { STATUS, STORAGE_KEYS } from '../constants'
import { Layout } from '../layout'
import { useAppDispatch, useAppSelector } from '../redux-store/hooks'
import { logIntoApp } from '../redux-store/reducers'
import { MaskLoader, StartupLoader } from '../screens'
import { LinearProgress } from '@mui/material'
import { SocketProvider } from '../realtime'

interface PrivateRouteProps {
  children: JSX.Element
  isLoaderActive: boolean
  toggleTheme: () => void
}

const DashboardPrivateRoute: FC<PrivateRouteProps> = ({
  children,
  isLoaderActive,
  toggleTheme,
}) => {
  const navigate = useNavigate()
  const dispatcher = useAppDispatch()
  const authToken = useAppSelector((state) => state.authentication.token)
  const loadState = useAppSelector((state) => state.clientInfo.status)
  const location = useLocation()
  const isKitchenRoute = location.pathname === '/app/kitchen'

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN)
    const userId = localStorage.getItem(STORAGE_KEYS.USER_ID)
    if (token && userId) {
      dispatcher(logIntoApp({ token, userId }))
    } else {
      navigate('/login')
    }
  }, [authToken, loadState, navigate, dispatcher])

  if (loadState !== STATUS.SUCCESS) {
    return <StartupLoader />
  }

  return (
    <>
      {isLoaderActive &&
        (isKitchenRoute ? (
          <LinearProgress
            color="warning"
            sx={{ position: 'absolute', top: 0, width: '100%', zIndex: 10 }}
          />
        ) : (
          <MaskLoader />
        ))}
        {/* {isLoaderActive && <MaskLoader />} */}
        <Layout isLoaderActive={isLoaderActive} toggleTheme={toggleTheme}>
          {children}
        </Layout>
    </>
  )
}

export default DashboardPrivateRoute
